/**
 * Care Plan Service
 * Patient care plan management and tracking API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RecreateWorkItemsRequestDto { 
    /**
     * Allow duplicate work items to be created even if similar ones exist
     */
    allowDuplicates?: boolean;
    /**
     * Fields to expand in the response
     */
    expand?: Array<RecreateWorkItemsRequestDto.ExpandEnum>;
}
export namespace RecreateWorkItemsRequestDto {
    export type ExpandEnum = 'care-plan-type' | 'work-items' | 'encounters' | 'observation-types';
    export const ExpandEnum = {
        CarePlanType: 'care-plan-type' as ExpandEnum,
        WorkItems: 'work-items' as ExpandEnum,
        Encounters: 'encounters' as ExpandEnum,
        ObservationTypes: 'observation-types' as ExpandEnum
    };
}


